function getLanguagePath(){
	return __('language.path');
}

export {getLanguagePath};